import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import MenuPage from "@/pages/MenuPage";
import GalleryPage from "@/pages/GalleryPage";
import CateringPage from "@/pages/CateringPage";
import VisitPage from "@/pages/VisitPage";
import StoryPage from "@/pages/StoryPage";
import PrivacyPage from "@/pages/PrivacyPage";
import NotFoundPage from "@/pages/NotFoundPage";
import { BirriaTacosLanding, BirriaCateringLanding } from "@/pages/LandingPages";

function App() {
  return (
    <div className="App min-h-screen bg-hacienda-white">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="menu" element={<MenuPage />} />
              <Route path="gallery" element={<GalleryPage />} />
              <Route path="catering" element={<CateringPage />} />
              <Route path="our-story" element={<StoryPage />} />
              <Route path="visit-us" element={<VisitPage />} />
              <Route path="contact" element={<Navigate to="/visit-us" replace />} />
              <Route path="privacy-policy" element={<PrivacyPage />} />
              <Route path="birria-tacos-albuquerque" element={<BirriaTacosLanding />} />
              <Route path="birria-catering-albuquerque" element={<BirriaCateringLanding />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </LanguageProvider>
    </div>
  );
}

export default App;
